import { render, staticRenderFns } from "./AllProducts.vue?vue&type=template&id=4eefcf04&scoped=true"
import script from "./AllProducts.vue?vue&type=script&lang=ts"
export * from "./AllProducts.vue?vue&type=script&lang=ts"
import style0 from "./AllProducts.vue?vue&type=style&index=0&id=4eefcf04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eefcf04",
  null
  
)

export default component.exports